const PaymentMethods = {
    ACCOUNT_PAYABLE: 8,
  };
  
  export default PaymentMethods;
  